import type { Ref } from "vue";

export const destroySwiperInstance = (instanceRef: Ref<any | null>) => {
  if (instanceRef.value) {
    instanceRef.value.destroy(true, true);
    instanceRef.value = null;
  }
};
